import React from 'react'
import { findingSettingEdit } from '../../../../redux/actions/settingActions/findingSettingActions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as $ from 'jquery'
import { useSettingFieldType } from '../helpers/useSettingFieldType';

export default function FindingSetting(props) {
  const { baseName, isVisible } = props
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const findingName = useSettingFieldType(baseName)
  const showFindingButton = pathname === '/settings/exam-form-template' ||
    /^\/organisation\/staffs\/\d+\/exam-templates/.test(pathname)

  const handleFindingModal = (e) => {
    e.preventDefault();
    showFindingSettingModal()
    $('#findingSettingForm-modal').modal('show')
  }

  const showFindingSettingModal = () => {
    dispatch(findingSettingEdit({ test_type: findingName }))
  }

  return (
    <span className={`mr-3 ${(!showFindingButton || !isVisible) && 'd-none'}`} onClick={handleFindingModal}>
      <i className="las la-search-plus font-size-18"></i>
    </span>
  )
}
